import StaffGrossSalesReducer from "./redux/staffGrossSalesReducer";
import StaffGrossSalesSaga from "./redux/staffGrossSalesSaga";
import { StaffGrossSalesModule } from "./staffGrossSalesModule";

export default {
  Component: StaffGrossSalesModule,
  moduleName: "staffGrossSales",
  saga: StaffGrossSalesSaga(),
  reducer: StaffGrossSalesReducer
};
